(function ($) {
    if ( window.innerWidth > 992) {
        function matchHeights() {
            var elements = document.querySelectorAll('.cardsMatchHeight');
            var minHeight = 0;
            elements.forEach(function (element) {
                var height = element.clientHeight;
                minHeight = Math.max(minHeight, height);
            });
            elements.forEach(function (element) {
                element.style.minHeight = minHeight + 'px';
            });
        }
        window.onload = function () {
            matchHeights();
        };
    }
})(jQuery);